import { useCourseDetailStore } from "@/stores/courseDetailStore";
import { subchaptersOf } from "@/lib/chapterNavigation";
import { CourseTreeNodeTypeEnum } from "@/types/generated";

/**
 * First subchapter id of the selected chapter — used when intro embeds that
 * subchapter’s content while the route still selects the chapter node.
 */
const useFirstSubChapterId = (): string | undefined => {
  const selectedNodeId = useCourseDetailStore((state) => state.selectedNodeId);
  const nodeIndex = useCourseDetailStore((state) => state.nodeIndex);

  const selectedNode = selectedNodeId
    ? nodeIndex.get(selectedNodeId)?.node
    : undefined;

  if (selectedNode?.type !== CourseTreeNodeTypeEnum.Chapter) {
    return undefined;
  }

  return subchaptersOf(selectedNode)[0]?.id;
};

export { useFirstSubChapterId };
